export default __webpack_public_path__ + "media/projects/red1-d5e62c47.svg";